import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconAngleDown: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00002 11.1667C7.87202 11.1667 7.744 11.118 7.64666 11.02L2.98 6.35337C2.78466 6.15804 2.78466 5.84135 2.98 5.64601C3.17533 5.45068 3.49202 5.45068 3.68735 5.64601L8.00067 9.95933L12.314 5.64601C12.5093 5.45068 12.826 5.45068 13.0213 5.64601C13.2167 5.84135 13.2167 6.15804 13.0213 6.35337L8.35467 11.02C8.256 11.118 8.12802 11.1667 8.00002 11.1667Z"
      fill={color}
    />
  </svg>
);

export default IconAngleDown;
